import React, { useState, useEffect } from 'react'

const OPEN_JUMP_CHANGE_DETAILS = `
        <span style="font-size: 0.9em;">DeForest: Tues &amp; Thurs 12&ndash;2pm, Fri 7:30&ndash;9pm, Sat 12&ndash;2pm</span>
        <span style="font-size: 0.9em; margin-left: 0.25em; margin-right: 0.25em;"> | </span>
        <span style="font-size: 0.9em;">Both gyms: $15/child</span>
`

const BANNER_MESSAGES = [
  // Reopening day: the change lands the same morning we come back from the
  // Back to School Break, so the two messages are folded into one banner.
  {
    startDate: new Date('September 8, 2026'),
    endDate: new Date('September 8, 2026 11:59 PM'),
    content: `
      <p style="text-wrap: balance;">
        ⭐ <strong class='tracking-wide'>We Reopen Today &ndash; New Open Jump Times &amp; Pricing</strong> ⭐
        <br/>
        ${OPEN_JUMP_CHANGE_DETAILS}
      </p>
    `,
  },
  {
    startDate: new Date('September 9, 2026'),
    endDate: new Date('October 4, 2026 11:59 PM'),
    content: `
      <p style="text-wrap: balance;">
        ⭐ <strong class='tracking-wide'>New Open Jump Times &amp; Pricing</strong> ⭐
        <br/>
        ${OPEN_JUMP_CHANGE_DETAILS}
      </p>
    `,
  },
  {
    startDate: new Date('August 27, 2026'),
    endDate: new Date('September 7, 2026 11:59 PM'),
    content: `
      <p style="text-wrap: balance;">
        🎒 <strong class='tracking-wide'>Back to School Break: Closed Aug 31&ndash;Sept 7</strong> 🎒
        <br/>
        <span style="font-size: 0.9em;">No Classes or Open Jumps, including Labor Day. We reopen Tuesday, September 8!</span>
      </p>
    `,
  },
  {
    startDate: new Date('June 29, 2026'),
    endDate: new Date('July 5, 2026'),
    content: `
      <p style="text-wrap: balance;">
        🇺🇸 <strong class='tracking-wide'>Closed June 29&ndash;July 5 for all Classes &amp; Open Jumps</strong> 🇺🇸
        <br/>
        <span style="font-size: 0.9em;">🎆 Happy 4th of July! We'll see you when we reopen. 🎆</span>
      </p>
    `,
  },
  {
    startDate: new Date('Mar 17, 2026'),
    endDate: new Date('Apr 4, 2026'),
    content: `
      <p style="text-wrap: balance;">
        ☀️ <strong class='tracking-wide'>Spring Break Closures</strong> ☀️
        <br/>
        <span style="font-size: 0.9em;">DeForest: 3/23 - 3/28</span>
        <span style="font-size: 0.9em; margin-left: 0.25em; margin-right: 0.25em;"> | </span>
        <span style="font-size: 0.9em;">Cottage Grove: 3/30 - 4/4</span>
      </p>
    `,
  },
]

const getActiveBannerContent = () => {
  const now = new Date().getTime()
  const activeMessages = BANNER_MESSAGES.filter(msg => {
    return (
      (!msg.startDate || msg.startDate.getTime() <= now) &&
      msg.endDate.getTime() >= now
    )
  })

  return activeMessages.length > 0
    ? activeMessages.map(msg => msg.content).join('')
    : null
}

const BannerMessages = () => {
  const [content, setContent] = useState(null)

  useEffect(() => {
    setContent(getActiveBannerContent())
  }, [])

  return content ? (
    <section
      id="banner"
      className="z-50 w-full p-4 md:py-4 mb-1 bg-gradient-purple text-grey-lightest leading-normal"
    >
      <div className="container mx-auto">
        <div className="flex">
          <div className="w-full text-center">
            <div className="flex flex-wrap">
              <div
                className="mx-auto"
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null
}

export default BannerMessages
